import { IMappedSocialLink } from 'shared/types/socials';
import { Socials } from '../Socials';
import * as styles from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';
import { CianLogoSign } from '@cian/ui-kit-design-tokens/logo';

interface IFooterProps {
  socialItems: ReadonlyArray<IMappedSocialLink>;
  device: TDeviceType;
}

export const Footer: React.FC<IFooterProps> = ({ socialItems, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <CianLogoSign colorType="onBright" size={device === 'phone' ? 20 : 28} />
        <Socials items={socialItems} bgColor="#FFFFFF" color="brand-navy" />
      </div>
    </div>
  );
};
